/* unplugin-vue-components disabled */const { computed, ref, watchEffect, onBeforeMount, nextTick, onMounted } = require('vue');
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_1 = require("vue");
const vue_2 = require("vue");
const _withScopeId = n => ((0, vue_2.pushScopeId)("data-v-4c9df9e0"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = { class: "impl-wrap" };
const _hoisted_2 = { class: "slider-panel-wrap" };
const _hoisted_3 = { class: "border-panel" };
const _hoisted_4 = { class: "run-file-wrap" };
const _hoisted_5 = { class: "mode-btn-group" };
const _hoisted_6 = { class: "main-btn-wrap" };
const _hoisted_7 = { class: "slider-panel-wrap" };
const _hoisted_8 = { class: "io-run-panel" };
const _hoisted_9 = { class: "point-btn-wrap" };
const _hoisted_10 = { class: "main-btn-wrap" };
const Rocker_vue_1 = tslib_1.__importDefault(require("./components/Rocker.vue"));
const CtrlBtn_vue_1 = tslib_1.__importDefault(require("./components/CtrlBtn.vue"));
const PointListPanel_vue_1 = tslib_1.__importDefault(require("./components/PointListPanel.vue"));
const CoordList_vue_1 = tslib_1.__importDefault(require("./components/CoordList.vue"));
const index_vue_1 = tslib_1.__importDefault(require("@/components/RobotCustomConfig/index.vue"));
const IoList_vue_1 = tslib_1.__importDefault(require("./components/IoList.vue"));
const work_1 = require("@/store/modules/work");
const model_1 = require("@/model");
const service_1 = require("@/rpc/service");
const api_1 = tslib_1.__importDefault(require("@/api"));
const project_1 = require("@/service/project");
const one_message_1 = require("@/utils/one_message");
const utils_1 = require("@/utils");
const loading_1 = require("@/utils/loading");
const laborer_1 = require("@/store/modules/laborer");
const user_1 = require("@/service/user");
const router_1 = tslib_1.__importDefault(require("@/router"));
var ROCKER_MOVE_STATE;
(function (ROCKER_MOVE_STATE) {
    ROCKER_MOVE_STATE[ROCKER_MOVE_STATE["IDLE"] = 0] = "IDLE";
    ROCKER_MOVE_STATE[ROCKER_MOVE_STATE["WORKING"] = 1] = "WORKING";
    ROCKER_MOVE_STATE[ROCKER_MOVE_STATE["SENDING"] = 2] = "SENDING";
    ROCKER_MOVE_STATE[ROCKER_MOVE_STATE["STOPING"] = 3] = "STOPING";
})(ROCKER_MOVE_STATE || (ROCKER_MOVE_STATE = {}));
var CTRL_MOVE_STATE;
(function (CTRL_MOVE_STATE) {
    CTRL_MOVE_STATE[CTRL_MOVE_STATE["IDLE"] = 0] = "IDLE";
    CTRL_MOVE_STATE[CTRL_MOVE_STATE["WORKING"] = 1] = "WORKING";
    CTRL_MOVE_STATE[CTRL_MOVE_STATE["SENDING"] = 2] = "SENDING";
    CTRL_MOVE_STATE[CTRL_MOVE_STATE["STOPING"] = 3] = "STOPING";
})(CTRL_MOVE_STATE || (CTRL_MOVE_STATE = {}));
var FILE_RUN_STATE;
(function (FILE_RUN_STATE) {
    FILE_RUN_STATE[FILE_RUN_STATE["IDLE"] = 0] = "IDLE";
    FILE_RUN_STATE[FILE_RUN_STATE["SENDING"] = 1] = "SENDING";
    FILE_RUN_STATE[FILE_RUN_STATE["RUNNING"] = 2] = "RUNNING";
    FILE_RUN_STATE[FILE_RUN_STATE["STOPING"] = 3] = "STOPING";
})(FILE_RUN_STATE || (FILE_RUN_STATE = {}));
var SINGLE_POINT_STATE;
(function (SINGLE_POINT_STATE) {
    SINGLE_POINT_STATE[SINGLE_POINT_STATE["IDLE"] = 0] = "IDLE";
    SINGLE_POINT_STATE[SINGLE_POINT_STATE["RUNNING"] = 1] = "RUNNING";
    SINGLE_POINT_STATE[SINGLE_POINT_STATE["STOPING"] = 2] = "STOPING";
})(SINGLE_POINT_STATE || (SINGLE_POINT_STATE = {}));
const fileRunningMsg = "程序正在运行，请停止程序运行或等待程序运行程序完毕后再试！";
const pointRunningMsg = "正在单点运行，请取消单点运行或等待单点运行结束后再试!";
const robotRunningTips = '正在与机器人交互，请取消交互后再试！';
var TOOL_BOX_CMD;
(function (TOOL_BOX_CMD) {
    TOOL_BOX_CMD[TOOL_BOX_CMD["LEVELLING"] = 0] = "LEVELLING";
    TOOL_BOX_CMD[TOOL_BOX_CMD["RECONNECT"] = 1] = "RECONNECT";
    TOOL_BOX_CMD[TOOL_BOX_CMD["RESET_POINT_DATA"] = 2] = "RESET_POINT_DATA";
})(TOOL_BOX_CMD || (TOOL_BOX_CMD = {}));
exports.default = (0, vue_1.defineComponent)(Object.assign({
    name: 'laborer'
}, { __name: 'index', emits: ['openProject'], setup(__props, { expose: __expose, emit: __emit }) {
        const curProgram = computed(() => { var _a; return (_a = model_1.Project.current()) === null || _a === void 0 ? void 0 : _a.curProgram; });
        const PANEL_NAME = {
            POINT_LIST: "点位列表",
            IO_LIST: "信号口列表",
            COORD_LIST: "坐标系列表"
        };
        const curSinglePointState = ref(SINGLE_POINT_STATE.IDLE);
        const curFileRunState = ref(FILE_RUN_STATE.IDLE);
        const curCtrlMoveState = ref(CTRL_MOVE_STATE.IDLE);
        const activeName = ref(PANEL_NAME.POINT_LIST);
        const showConnectRobot = ref(false);
        const modeModel = ref('平移模式');
        const isLineMode = computed(() => modeModel.value === '平移模式');
        const robotConfigDialog = ref();
        const ctrlBtnRef = ref();
        const ioPanelRef = ref();
        const workStore = (0, work_1.useWork)();
        const laborerStore = (0, laborer_1.useLaborer)();
        const rockerRef = ref();
        const curRockerState = ref(ROCKER_MOVE_STATE.IDLE);
        const emit = __emit;
        watchEffect(() => {
            if (curFileRunState.value !== FILE_RUN_STATE.IDLE
                || curSinglePointState.value !== SINGLE_POINT_STATE.IDLE
                || ['connecting', 'reconnecting'].includes(laborerStore.robotConnectState)
                || curCtrlMoveState.value !== CTRL_MOVE_STATE.IDLE
                || curRockerState.value !== ROCKER_MOVE_STATE.IDLE) {
                laborerStore.isRobotMoving = true;
            }
            else {
                laborerStore.isRobotMoving = false;
            }
        });
        const isStopCtrlBtn = computed(() => {
            let result = curFileRunState.value !== FILE_RUN_STATE.IDLE
                || curSinglePointState.value !== SINGLE_POINT_STATE.IDLE
                || ['connecting', 'reconnecting'].includes(laborerStore.robotConnectState)
                || curRockerState.value !== ROCKER_MOVE_STATE.IDLE;
            return result;
        });
        const isDevMode = computed(() => laborerStore.mode === 'dev');
        const teachPendantSpeed = ref();
        const robotSpeedOptions = [{ value: 5, label: '5%' }, { value: 15, label: '15%' }, { value: 45, label: '45%' }, { value: 75, label: '75%' }, { value: 100, label: '100%' }];
        const pointListPanelRef = ref();
        const coordListRef = ref();
        const curPage = computed(() => router_1.default.currentRoute.value.name);
        watchEffect(() => {
            showConnectDialog();
        });
        onBeforeMount(() => tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield nextTick(() => tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a;
                if (curPage.value === 'laborer' && !model_1.Project.current()) {
                    try {
                        yield project_1.ProjectService.current().openLastOpenProject();
                    }
                    catch (e) {
                        if (e.message.includes("无工程，请新建")) {
                            if (yield user_1.permService.hasDesign()) {
                                yield router_1.default.push({ name: 'design' });
                                return;
                            }
                            else {
                                one_message_1.oneMessage.error("账号暂无权限创建项目，请联系管理员");
                            }
                        }
                    }
                }
                let robots = (_a = model_1.Project.current()) === null || _a === void 0 ? void 0 : _a.findMachineByType(model_1.ENTITY_TYPE.ROBOT);
                if (!(robots === null || robots === void 0 ? void 0 : robots.length)) {
                    if (yield user_1.permService.hasDesign()) {
                        yield router_1.default.push({ name: 'design' });
                    }
                    else {
                        (0, one_message_1.oneMessage)({
                            message: "无程序，请联系工程师",
                            grouping: true,
                            type: 'warning'
                        });
                    }
                }
            }));
        }));
        onMounted(() => tslib_1.__awaiter(this, void 0, void 0, function* () {
            showConnectDialog();
            if (laborerStore.robotConnectState === 'connected') {
                yield checkRobotSpeed();
            }
        }));
        function onReconnect() {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                if (!robotConfigDialog.value || !curProgram.value) {
                    throw new Error('component is null');
                }
                if (laborerStore.isRobotMoving) {
                    yield robotService.stopRobot();
                }
                laborerStore.robotConnectState = 'disconnect';
            });
        }
        function showConnectDialog() {
            if (laborerStore.robotConnectState !== 'connected') {
                if (!robotConfigDialog.value || !curProgram.value) {
                    return;
                }
                robotConfigDialog.value.openRobotConfig();
            }
        }
        function resetPointData() {
            var _a, _b;
            if (activeName.value === PANEL_NAME.POINT_LIST) {
                let paths = (_a = model_1.Project.current()) === null || _a === void 0 ? void 0 : _a.curProgram.robot.paths.filter(path => path.isTeach);
                if (!paths || paths.length === 0) {
                    (0, one_message_1.oneMessage)('无需重置点位信息');
                    return;
                }
                paths.forEach(path => {
                    let points = path.points;
                    path.points = points.map(item => item.map(() => 0));
                });
            }
            else if (activeName.value === PANEL_NAME.COORD_LIST) {
                let rpList = (_b = model_1.Project.current()) === null || _b === void 0 ? void 0 : _b.curProgram.robot.tcps.filter(tcp => tcp.reference.frame === 'rp');
                if (!rpList || rpList.length === 0) {
                    (0, one_message_1.oneMessage)('无需重置点位信息');
                    return;
                }
                rpList.forEach(rp => {
                    rp.resetRefPointsData();
                });
            }
            one_message_1.oneMessage.success('点位信息重置成功！');
        }
        let checkRunningIntervalIds = [];
        function handleRunningCode() {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                if (isDevMode.value) {
                    one_message_1.oneMessage.warning('未正确连接机器人，请重新连接机器人！');
                    return;
                }
                if (laborerStore.isRobotMoving)
                    return;
                try {
                    (0, loading_1.openLoading)({
                        text: "正在生成程序"
                    });
                    let routes = curProgram.value.robot.paths.filter(path => ['route', 'point', 'joints', 'jointPoint'].includes(path.type) && path.isTeach);
                    if (!pointListPanelRef.value.hasAutoAdd)
                        routes = routes.filter(path => !path.ioId);
                    const checkPointSaved = (point) => {
                        let count = 0;
                        point.forEach(num => {
                            if (num === 0) {
                                count++;
                            }
                        });
                        if (count === point.length) {
                            throw new Error('存在未存点的空点，会导致机器人运行异常，请删除或存点后重试！');
                        }
                    };
                    for (let i = 0; i < routes.length; i++) {
                        let route = routes[i];
                        for (let j = 0; j < route.points.length; j++) {
                            checkPointSaved(route.points[j]);
                        }
                    }
                    let rpList = model_1.Project.current().curProgram.robot.tcps.filter(tcp => tcp.reference.frame === 'rp');
                    for (let i = 0; i < rpList.length; i++) {
                        let refPoints = [rpList[i].refPoints.R1, rpList[i].refPoints.R2, rpList[i].refPoints.R3];
                        for (let j = 0; j < refPoints.length; j++) {
                            checkPointSaved(refPoints[j].data[0]);
                        }
                    }
                    let project = model_1.Project.current();
                    let pg = model_1.ProgramsData.fromProject(project);
                    curFileRunState.value = FILE_RUN_STATE.SENDING;
                    let data = pg.toJson();
                    data.brand = 'elite2';
                    let res = yield (0, api_1.default)('program.text', data);
                    if (res.message)
                        throw new Error(`生成代码失败！${res.message}`);
                    (0, loading_1.openLoading)({
                        text: "正在发送程序"
                    });
                    let mainFilename = '';
                    let fileDataList = [];
                    for (let filename in res) {
                        if (filename.split('.')[0] === 'main') {
                            mainFilename = filename;
                        }
                        fileDataList.push({ filename: filename, content: res[filename] });
                    }
                    let uploadRes = yield robotService.upload(fileDataList);
                    if (!uploadRes.success) {
                        throw new Error(`上传代码失败${uploadRes.msg}`);
                    }
                    (0, loading_1.openLoading)({
                        text: "发送运行命令"
                    });
                    if (!mainFilename.length)
                        throw new Error("找不到主程序");
                    yield robotService.setRobotPrepareMove([0, 0, 0, 0, 0, 0]);
                    let runFileRes = yield robotService.runFile(mainFilename);
                    if (runFileRes.success) {
                        curFileRunState.value = FILE_RUN_STATE.RUNNING;
                        let isWaitingGetState = false;
                        let intervalId = setInterval(() => tslib_1.__awaiter(this, void 0, void 0, function* () {
                            if (isWaitingGetState)
                                return;
                            try {
                                isWaitingGetState = true;
                                let stateRes = yield robotService.getFileRunningState();
                                if (checkRunningIntervalIds.findIndex(id => id === intervalId) < 0) {
                                    return;
                                }
                                if (stateRes.success) {
                                    if (stateRes.runState !== 'running' && stateRes.runState !== 'paused') {
                                        if (stateRes.runState === 'stop')
                                            (0, one_message_1.oneMessage)({ message: "程序运行完毕", type: 'success' });
                                        else if (stateRes.runState === 'egcStop')
                                            (0, one_message_1.oneMessage)({ message: "程序运行急停", type: "error" });
                                        else if (stateRes.runState === 'error')
                                            (0, one_message_1.oneMessage)({ message: "程序运行错误", type: "error" });
                                        yield handleStopCode(false);
                                    }
                                }
                                else {
                                    throw new Error("获取程序运行状态失败");
                                }
                            }
                            catch (e) {
                                if (checkRunningIntervalIds.findIndex(id => id === intervalId) < 0)
                                    return;
                                (0, one_message_1.oneMessage)({ message: e.message || JSON.stringify(e), type: 'error' });
                            }
                            finally {
                                isWaitingGetState = false;
                            }
                        }), 500);
                        checkRunningIntervalIds.push(intervalId);
                    }
                    else {
                        throw new Error(`运行代码失败,${runFileRes.msg}`);
                    }
                }
                catch (e) {
                    (0, one_message_1.oneMessage)({ message: e.message || JSON.stringify(e), type: 'error' });
                    curFileRunState.value = FILE_RUN_STATE.IDLE;
                    console.error(e);
                }
                finally {
                    (0, loading_1.closeLoading)();
                }
            });
        }
        function handleStopCode(stopRobot = true) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                if (isDevMode.value) {
                    one_message_1.oneMessage.warning('未正确连接机器人，请重新连接机器人！');
                    return;
                }
                try {
                    (0, loading_1.openLoading)({
                        text: "正在停止程序"
                    });
                    curFileRunState.value = FILE_RUN_STATE.IDLE;
                    if (stopRobot)
                        yield robotService.stopRobot();
                }
                catch (e) {
                    console.error(e);
                }
                finally {
                    checkRunningIntervalIds.forEach(id => {
                        clearInterval(id);
                    });
                    (0, loading_1.closeLoading)();
                }
            });
        }
        const isSuportRunFile = computed(() => {
            return utils_1.Utils.isIPad();
        });
        let controlMoveAngle = 0;
        let toRockerCenter = 0;
        let curSpeed = computed(() => ctrlBtnRef.value.curSpeed);
        function onCtrlStopEvt() {
            one_message_1.oneMessage.warning(fileRunningMsg);
        }
        let ctrlBtnMoveActionId;
        function ctrlBtnMove(evtName) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                if (isDevMode.value) {
                    one_message_1.oneMessage.warning('未正确连接机器人，请重新连接机器人！');
                    return;
                }
                clearRobotMoveInterval();
                if (curCtrlMoveState.value !== CTRL_MOVE_STATE.IDLE) {
                    throw new Error(`ctrl move button state error: ${CTRL_MOVE_STATE[curCtrlMoveState.value]}`);
                }
                curCtrlMoveState.value = CTRL_MOVE_STATE.WORKING;
                let moveIntervalID;
                let innerMoveActionId = ctrlBtnMoveActionId = Date.now();
                const sendMoveRequest = () => tslib_1.__awaiter(this, void 0, void 0, function* () {
                    switch (evtName) {
                        case 'moveUp':
                            yield robotService.moveUp(curSpeed.value);
                            break;
                        case 'moveDown':
                            yield robotService.moveDown(curSpeed.value);
                            break;
                        case 'rotatLeft':
                            yield robotService.rotateLeft(curSpeed.value);
                            break;
                        case 'rotatRight':
                            yield robotService.rotateRight(curSpeed.value);
                            break;
                    }
                });
                const inWorkingState = () => tslib_1.__awaiter(this, void 0, void 0, function* () {
                    if (![CTRL_MOVE_STATE.WORKING, CTRL_MOVE_STATE.SENDING].includes(curCtrlMoveState.value)) {
                        clearRobotMoveInterval();
                        throw new Error(`ctrl move button state error: ${CTRL_MOVE_STATE[curCtrlMoveState.value]}`);
                    }
                    if (curCtrlMoveState.value === CTRL_MOVE_STATE.SENDING)
                        return;
                    try {
                        curCtrlMoveState.value = CTRL_MOVE_STATE.SENDING;
                        yield sendMoveRequest();
                    }
                    catch (e) {
                        if (!checkRobotMoveIntervalInUsing(moveIntervalID))
                            return;
                        (0, one_message_1.oneMessage)({ message: e.message || e, type: 'error' });
                    }
                    finally {
                        if (innerMoveActionId === ctrlBtnMoveActionId)
                            curCtrlMoveState.value = CTRL_MOVE_STATE.WORKING;
                    }
                });
                curCtrlMoveState.value = CTRL_MOVE_STATE.SENDING;
                try {
                    yield robotService.setRobotPrepareMove([0, 0, 0, 0, 0, 0]);
                    if (innerMoveActionId !== ctrlBtnMoveActionId)
                        return;
                    yield sendMoveRequest();
                }
                catch (e) {
                    console.error(e);
                    if (innerMoveActionId !== ctrlBtnMoveActionId)
                        return;
                    (0, one_message_1.oneMessage)({ message: e.message || e, type: 'error' });
                    curCtrlMoveState.value = CTRL_MOVE_STATE.IDLE;
                    return;
                }
                if (innerMoveActionId !== ctrlBtnMoveActionId)
                    return;
                curCtrlMoveState.value = CTRL_MOVE_STATE.WORKING;
                moveIntervalID = addRobotMoveInterval(inWorkingState, 500);
            });
        }
        function ctrlBtnStop(mode) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                if (isDevMode.value) {
                    one_message_1.oneMessage.warning('未正确连接机器人，请重新连接机器人！');
                    return;
                }
                ctrlBtnMoveActionId++;
                clearRobotMoveInterval();
                curCtrlMoveState.value = CTRL_MOVE_STATE.IDLE;
                try {
                    yield robotService.stopRobot();
                }
                catch (e) {
                    console.error(e);
                }
                finally {
                }
            });
        }
        function onCenterLeftClk(mode) {
            if (!ctrlBtnRef.value) {
                return;
            }
            ctrlBtnRef.value.changeSpeed();
        }
        function savePoint() {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                if (isDevMode.value) {
                    one_message_1.oneMessage.warning('未正确连接机器人，请重新连接机器人！');
                    return;
                }
                if (!laborerStore.pointState) {
                    (0, one_message_1.oneMessage)("请选择一个点，再进行存点！");
                    return;
                }
                if (laborerStore.isRobotMoving) {
                    one_message_1.oneMessage.warning(robotRunningTips);
                    return;
                }
                try {
                    if (laborerStore.pointState.path.type === 'coord') {
                        let robotPointRes = yield robotService.getCurPoint();
                        let robotJointRes = yield robotService.getCurJoints();
                        if (!reduceResponse(robotJointRes) || !reduceResponse(robotPointRes))
                            return;
                        robotPointRes.pose.forEach((item, index) => {
                            laborerStore.pointState.path['refPointsData'][0][index] = item;
                        });
                        robotJointRes.joints.forEach((item, index) => {
                            laborerStore.pointState.path['refPointsData'][1][index] = item;
                        });
                    }
                    else if (!['joints', 'jointPoint'].includes(laborerStore.pointState.path.type)) {
                        let robotPointRes = yield robotService.getCurPoint();
                        if (!reduceResponse(robotPointRes))
                            return;
                        robotPointRes.pose.forEach((item, index) => {
                            laborerStore.pointState.curPoint[index] = item;
                        });
                    }
                    else {
                        let robotJointRes = yield robotService.getCurJoints();
                        if (!reduceResponse(robotJointRes))
                            return;
                        robotJointRes.joints.forEach((item, index) => {
                            laborerStore.pointState.curPoint[index] = item;
                        });
                    }
                    laborerStore.editPoint();
                    if (activeName.value === PANEL_NAME.POINT_LIST) {
                        pointListPanelRef.value.playSavePointAnimate();
                    }
                    else if (activeName.value === PANEL_NAME.COORD_LIST) {
                        coordListRef.value.playSavePointAnimate();
                    }
                }
                catch (e) {
                    one_message_1.oneMessage.error(e.message);
                }
            });
        }
        let singlePointIntervalIds = [];
        const clearSinglePointInterval = () => {
            singlePointIntervalIds.forEach(id => clearInterval(id));
            singlePointIntervalIds.splice(0, singlePointIntervalIds.length);
        };
        function singlePointRun() {
            var _a;
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                if (isDevMode.value) {
                    one_message_1.oneMessage.warning('未正确连接机器人，请重新连接机器人！');
                    return;
                }
                if (curSinglePointState.value === SINGLE_POINT_STATE.RUNNING) {
                    curSinglePointState.value = SINGLE_POINT_STATE.STOPING;
                    try {
                        clearSinglePointInterval();
                        curSinglePointState.value = SINGLE_POINT_STATE.IDLE;
                        yield robotService.stopRobot();
                    }
                    catch (e) {
                        console.log(e);
                    }
                }
                else if (curSinglePointState.value === SINGLE_POINT_STATE.IDLE) {
                    if (!((_a = laborerStore.pointState) === null || _a === void 0 ? void 0 : _a.curPoint)) {
                        (0, one_message_1.oneMessage)({ message: "请选择一个点后再进行单点运行！", type: 'warning' });
                        return;
                    }
                    for (let i = 0; i < laborerStore.pointState.curPoint.length; i++) {
                        if (laborerStore.pointState.curPoint[i] !== 0) {
                            break;
                        }
                        if (i === laborerStore.pointState.curPoint.length - 1) {
                            (0, one_message_1.oneMessage)({ message: "请存点后重试！", type: 'warning' });
                            return;
                        }
                    }
                    if (laborerStore.isRobotMoving) {
                        one_message_1.oneMessage.warning(robotRunningTips);
                        return;
                    }
                    curSinglePointState.value = SINGLE_POINT_STATE.RUNNING;
                    try {
                        yield robotService.setRobotPrepareMove([0, 0, 0, 0, 0, 0]);
                        let moveToPointRes;
                        if (['joints', 'jointPoint'].includes(laborerStore.pointState.path.type)) {
                            moveToPointRes = yield robotService.moveToJoint(laborerStore.pointState.curPoint, curSpeed.value);
                        }
                        else {
                            moveToPointRes = yield robotService.moveToPoint(laborerStore.pointState.curPoint, curSpeed.value);
                        }
                        if (!moveToPointRes.success) {
                            (0, one_message_1.oneMessage)({ message: moveToPointRes.msg, type: 'error' });
                            return;
                        }
                        let intervalId = setInterval(() => tslib_1.__awaiter(this, void 0, void 0, function* () {
                            var _b;
                            try {
                                let res = yield robotService.getRobotState();
                                if (singlePointIntervalIds.findIndex(id => id === intervalId) < 0) {
                                    return;
                                }
                                if (res.state !== 'running') {
                                    clearSinglePointInterval();
                                    curSinglePointState.value = SINGLE_POINT_STATE.IDLE;
                                    if (res.state === 'error') {
                                        throw new Error("机器人处于错误状态，请检查机器人状态");
                                    }
                                }
                            }
                            catch (e) {
                                if (e.message)
                                    (0, one_message_1.oneMessage)({ message: e.message, type: 'error' });
                                curSinglePointState.value = SINGLE_POINT_STATE.IDLE;
                                clearSinglePointInterval();
                                (_b = ctrlBtnRef.value) === null || _b === void 0 ? void 0 : _b.changeRunningPoint(false);
                                curSinglePointState.value = SINGLE_POINT_STATE.IDLE;
                            }
                        }), 500);
                        singlePointIntervalIds.push(intervalId);
                    }
                    catch (e) {
                        curSinglePointState.value = SINGLE_POINT_STATE.IDLE;
                        if (e.message)
                            (0, one_message_1.oneMessage)({ message: e.message, type: 'error' });
                    }
                }
            });
        }
        function levelling() {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                if (isDevMode.value) {
                    one_message_1.oneMessage.warning('未正确连接机器人，请重新连接机器人！');
                    return;
                }
                try {
                    let res = yield robotService.levelling();
                    reduceResponse(res);
                }
                catch (e) {
                    (0, one_message_1.oneMessage)({ message: e.message || e, type: 'error' });
                }
            });
        }
        function openCfg(id) {
            showConnectRobot.value = true;
        }
        let robotService = (0, service_1.useRobotService)('elite');
        let robotMoveAngle = controlMoveAngle + 1;
        function onRockerDown() {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                if (isDevMode.value) {
                    one_message_1.oneMessage.warning('未正确连接机器人，请重新连接机器人！');
                    return;
                }
                console.log("rocker down");
            });
        }
        let curRocker = 0;
        function onRockerMove(newMoveAngle, scale) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                if (isDevMode.value) {
                    one_message_1.oneMessage.warning('未正确连接机器人，请重新连接机器人！');
                    return;
                }
                if (curSinglePointState.value !== SINGLE_POINT_STATE.IDLE) {
                    one_message_1.oneMessage.warning(pointRunningMsg);
                    return;
                }
                if (curFileRunState.value !== FILE_RUN_STATE.IDLE) {
                    one_message_1.oneMessage.warning(fileRunningMsg);
                    return;
                }
                if (curCtrlMoveState.value !== CTRL_MOVE_STATE.IDLE) {
                    one_message_1.oneMessage.warning(robotRunningTips);
                    return;
                }
                let part = 2;
                let translatAngle = Math.round(newMoveAngle / (Math.PI / part)) * (Math.PI / part);
                if (Math.abs(translatAngle) === Math.PI) {
                    translatAngle = Math.PI;
                }
                controlMoveAngle = translatAngle;
                toRockerCenter = scale;
                if (toRockerCenter > 0.3 && curRockerState.value === ROCKER_MOVE_STATE.IDLE) {
                    curRockerState.value = ROCKER_MOVE_STATE.SENDING;
                    let innerRocker = ++curRocker;
                    let rockerMoveIntervalID;
                    const move = () => tslib_1.__awaiter(this, void 0, void 0, function* () {
                        try {
                            if (robotService) {
                                if (![ROCKER_MOVE_STATE.SENDING, ROCKER_MOVE_STATE.WORKING].includes(curRockerState.value)) {
                                    throw new Error("rocker in error state");
                                }
                                if (curRockerState.value === ROCKER_MOVE_STATE.SENDING)
                                    return;
                                curRockerState.value = ROCKER_MOVE_STATE.SENDING;
                                let controlMoveAngleSnap = controlMoveAngle;
                                if (Math.abs(robotMoveAngle - controlMoveAngleSnap) > 0.05) {
                                    yield robotService.stopRobot();
                                    if (rockerMoveIntervalID != null && !checkRobotMoveIntervalInUsing(rockerMoveIntervalID)) {
                                        console.log('定时器被清理，放弃jog');
                                        return;
                                    }
                                    yield robotService.setRobotPrepareMove([0, 0, 0, 0, 0, controlMoveAngleSnap]);
                                }
                                if (rockerMoveIntervalID != null && !checkRobotMoveIntervalInUsing(rockerMoveIntervalID)) {
                                    console.log('定时器被清理，放弃jog');
                                    return;
                                }
                                let res;
                                if (isLineMode.value) {
                                    res = yield robotService.moveLineByAngle(controlMoveAngleSnap, curSpeed.value);
                                }
                                else {
                                    res = yield robotService.moveRotateByAngle(controlMoveAngleSnap, curSpeed.value);
                                }
                                robotMoveAngle = controlMoveAngleSnap;
                                return reduceResponse(res);
                            }
                            else {
                                throw new Error('无法控制机器人，请重启软件');
                            }
                        }
                        catch (e) {
                            if (rockerMoveIntervalID != null && !checkRobotMoveIntervalInUsing(rockerMoveIntervalID)) {
                                console.log('定时器被清理，放弃jog');
                                return false;
                            }
                            (0, one_message_1.oneMessage)({ message: e.message || e, type: 'error' });
                            console.log(e);
                            return false;
                        }
                        finally {
                            if (curRocker === innerRocker)
                                curRockerState.value = ROCKER_MOVE_STATE.WORKING;
                        }
                    });
                    try {
                        yield robotService.setRobotPrepareMove([0, 0, 0, 0, 0, translatAngle]);
                        if (curRocker != innerRocker)
                            return;
                        if (isLineMode.value) {
                            yield robotService.moveLineByAngle(translatAngle, curSpeed.value);
                        }
                        else {
                            yield robotService.moveRotateByAngle(translatAngle, curSpeed.value);
                        }
                        robotMoveAngle = translatAngle;
                    }
                    catch (e) {
                        if (curRocker != innerRocker)
                            return;
                        (0, one_message_1.oneMessage)({ message: e.message || e, type: 'error' });
                        curRockerState.value = ROCKER_MOVE_STATE.IDLE;
                        return;
                    }
                    if (curRocker != innerRocker)
                        return;
                    curRockerState.value = ROCKER_MOVE_STATE.WORKING;
                    rockerMoveIntervalID = addRobotMoveInterval(move, 500);
                }
            });
        }
        function onRockerUp() {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                if (isDevMode.value) {
                    one_message_1.oneMessage.warning('未正确连接机器人，请重新连接机器人！');
                    return;
                }
                curRocker++;
                toRockerCenter = 0;
                controlMoveAngle = 0;
                if (curSinglePointState.value !== SINGLE_POINT_STATE.IDLE) {
                    one_message_1.oneMessage.warning(pointRunningMsg);
                    return;
                }
                if (curFileRunState.value !== FILE_RUN_STATE.IDLE) {
                    one_message_1.oneMessage.warning(fileRunningMsg);
                    return;
                }
                if (curCtrlMoveState.value !== CTRL_MOVE_STATE.IDLE) {
                    one_message_1.oneMessage.warning(robotRunningTips);
                    return;
                }
                clearRobotMoveInterval();
                curRockerState.value = ROCKER_MOVE_STATE.IDLE;
                yield robotService.stopRobot();
            });
        }
        const handleCommand = (command) => {
            if (laborerStore.isRobotMoving) {
                one_message_1.oneMessage.warning(robotRunningTips);
                return;
            }
            switch (command) {
                case TOOL_BOX_CMD.LEVELLING:
                    levelling();
                    break;
                case TOOL_BOX_CMD.RECONNECT:
                    onReconnect();
                    break;
                case TOOL_BOX_CMD.RESET_POINT_DATA:
                    resetPointData();
                    break;
            }
        };
        let robotMoveIntervalIDs = [];
        function addRobotMoveInterval(move, delay) {
            let id = setInterval(move, delay);
            robotMoveIntervalIDs.push(id);
            return id;
        }
        function clearRobotMoveInterval() {
            robotMoveIntervalIDs.forEach(id => {
                clearInterval(id);
            });
            robotMoveIntervalIDs.splice(0, robotMoveIntervalIDs.length);
        }
        function checkRobotMoveIntervalInUsing(checkId) {
            return robotMoveIntervalIDs.findIndex(id => id === checkId) >= 0;
        }
        let lastTeachPendantSpeed;
        function checkRobotSpeed() {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                let getRobotSpeedRes = yield robotService.getRobotSpeed();
                teachPendantSpeed.value = getRobotSpeedRes.speed + "%";
                lastTeachPendantSpeed = teachPendantSpeed.value;
            });
        }
        function onRobotSpeedChange(val) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                if (isDevMode.value) {
                    one_message_1.oneMessage.warning('未正确连接机器人，请重新连接机器人！');
                    return;
                }
                (0, loading_1.openLoading)({ text: "正在设置机器人速度" });
                try {
                    let robotSpeed = yield robotService.setRobotSpeed(val.value);
                    if (robotSpeed.success) {
                        lastTeachPendantSpeed = val.value;
                        teachPendantSpeed.value = val.label;
                        (0, one_message_1.oneMessage)({ message: "设置机器人速度成功", type: 'success' });
                    }
                    else {
                        throw new Error(robotSpeed.msg);
                    }
                }
                catch (e) {
                    teachPendantSpeed.value = lastTeachPendantSpeed;
                    (0, one_message_1.oneMessage)({ message: e.message || JSON.stringify(e), type: 'error' });
                }
                finally {
                    (0, loading_1.closeLoading)();
                }
            });
        }
        function onConnected() {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                yield checkRobotSpeed();
            });
        }
        function reduceResponse(res) {
            if (!(res === null || res === void 0 ? void 0 : res.success)) {
                (0, one_message_1.oneMessage)(res.msg);
                return false;
            }
            return true;
        }
        const refreshIo = (panelName) => {
            if (laborerStore.isRobotMoving) {
                one_message_1.oneMessage.warning(robotRunningTips);
                nextTick(() => activeName.value = PANEL_NAME.POINT_LIST);
                return;
            }
            laborerStore.selectPoint();
            if (ioPanelRef.value && panelName === PANEL_NAME.IO_LIST) {
                ioPanelRef.value.refresh();
            }
        };
        __expose({
            openCfg
        });
        return (_ctx, _cache) => {
            const _component_el_button = (0, vue_2.resolveComponent)("el-button");
            const _component_el_dropdown_item = (0, vue_2.resolveComponent)("el-dropdown-item");
            const _component_el_dropdown = (0, vue_2.resolveComponent)("el-dropdown");
            const _component_el_radio_button = (0, vue_2.resolveComponent)("el-radio-button");
            const _component_el_radio_group = (0, vue_2.resolveComponent)("el-radio-group");
            const _component_el_tab_pane = (0, vue_2.resolveComponent)("el-tab-pane");
            const _component_el_tabs = (0, vue_2.resolveComponent)("el-tabs");
            const _component_SuitcaseLine = (0, vue_2.resolveComponent)("SuitcaseLine");
            const _component_el_icon = (0, vue_2.resolveComponent)("el-icon");
            const _component_el_dropdown_menu = (0, vue_2.resolveComponent)("el-dropdown-menu");
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("div", {
                    class: (0, vue_2.normalizeClass)([{ 'el-overlay': (0, vue_2.unref)(activeName) === '信号口列表' }, "fixture-setting-active"])
                }, null, 2),
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    (0, vue_2.createElementVNode)("div", _hoisted_3, [
                        (0, vue_2.createElementVNode)("div", _hoisted_4, [
                            (0, vue_2.createElementVNode)("div", null, [
                                ((0, vue_2.unref)(curFileRunState) !== FILE_RUN_STATE.RUNNING)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_el_button, {
                                        key: 0,
                                        type: "success",
                                        size: "large",
                                        icon: "VideoPlay",
                                        onClick: handleRunningCode,
                                        class: "run-code-btn",
                                        disabled: !(0, vue_2.unref)(isSuportRunFile)
                                    }, {
                                        default: (0, vue_2.withCtx)(() => [
                                            (0, vue_2.createTextVNode)("运行程序 ")
                                        ]),
                                        _: 1
                                    }, 8, ["disabled"]))
                                    : ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_el_button, {
                                        key: 1,
                                        type: "danger",
                                        size: "large",
                                        icon: "VideoPause",
                                        onClick: _cache[0] || (_cache[0] = ($event) => (handleStopCode())),
                                        class: "run-code-btn",
                                        disabled: !(0, vue_2.unref)(isSuportRunFile)
                                    }, {
                                        default: (0, vue_2.withCtx)(() => [
                                            (0, vue_2.createTextVNode)("停止程序 ")
                                        ]),
                                        _: 1
                                    }, 8, ["disabled"]))
                            ]),
                            (0, vue_2.createElementVNode)("div", null, [
                                (0, vue_2.createVNode)(_component_el_dropdown, {
                                    onCommand: onRobotSpeedChange,
                                    trigger: "click",
                                    size: "large"
                                }, {
                                    dropdown: (0, vue_2.withCtx)(() => [
                                        ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(robotSpeedOptions, (speed) => {
                                            return (0, vue_2.createVNode)(_component_el_dropdown_item, {
                                                key: `robotSpeed${speed.value}`,
                                                command: speed
                                            }, {
                                                default: (0, vue_2.withCtx)(() => [
                                                    (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(speed.label), 1)
                                                ]),
                                                _: 2
                                            }, 1032, ["command"]);
                                        }), 64))
                                    ]),
                                    default: (0, vue_2.withCtx)(() => [
                                        (0, vue_2.createVNode)(_component_el_button, {
                                            size: "large",
                                            class: "change-speed-btn"
                                        }, {
                                            default: (0, vue_2.withCtx)(() => [
                                                (0, vue_2.createTextVNode)("运行速度:" + (0, vue_2.toDisplayString)((0, vue_2.unref)(teachPendantSpeed)), 1)
                                            ]),
                                            _: 1
                                        })
                                    ]),
                                    _: 1
                                })
                            ])
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_5, [
                            (0, vue_2.createVNode)(_component_el_radio_group, {
                                modelValue: (0, vue_2.unref)(modeModel),
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((0, vue_2.isRef)(modeModel) ? (modeModel).value = $event : null)),
                                size: "large"
                            }, {
                                default: (0, vue_2.withCtx)(() => [
                                    (0, vue_2.createVNode)(_component_el_radio_button, { label: "平移模式" }),
                                    (0, vue_2.createVNode)(_component_el_radio_button, { label: "翻转模式" })
                                ]),
                                _: 1
                            }, 8, ["modelValue"])
                        ])
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_6, [
                        (0, vue_2.createVNode)(Rocker_vue_1.default, {
                            onOnMouseDown: onRockerDown,
                            onOnMouseUp: onRockerUp,
                            onOnMouseMove: onRockerMove,
                            isLineMode: (0, vue_2.unref)(isLineMode),
                            ref_key: "rockerRef",
                            ref: rockerRef
                        }, null, 8, ["isLineMode"])
                    ])
                ]),
                (0, vue_2.createVNode)(_component_el_tabs, {
                    modelValue: (0, vue_2.unref)(activeName),
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((0, vue_2.isRef)(activeName) ? (activeName).value = $event : null)),
                    class: (0, vue_2.normalizeClass)(["center-panel-wrap", { 'fixture-active': (0, vue_2.unref)(activeName) === '信号口列表' }]),
                    onTabChange: refreshIo
                }, {
                    default: (0, vue_2.withCtx)(() => [
                        (0, vue_2.createVNode)(_component_el_tab_pane, {
                            label: PANEL_NAME.POINT_LIST,
                            name: PANEL_NAME.POINT_LIST
                        }, {
                            default: (0, vue_2.withCtx)(() => [
                                (0, vue_2.createVNode)(PointListPanel_vue_1.default, {
                                    ref_key: "pointListPanelRef",
                                    ref: pointListPanelRef
                                }, null, 512)
                            ]),
                            _: 1
                        }, 8, ["label", "name"]),
                        (0, vue_2.createVNode)(_component_el_tab_pane, {
                            label: PANEL_NAME.IO_LIST,
                            name: PANEL_NAME.IO_LIST
                        }, {
                            default: (0, vue_2.withCtx)(() => [
                                (0, vue_2.createVNode)(IoList_vue_1.default, {
                                    ref_key: "ioPanelRef",
                                    ref: ioPanelRef
                                }, null, 512)
                            ]),
                            _: 1
                        }, 8, ["label", "name"]),
                        (0, vue_2.createVNode)(_component_el_tab_pane, {
                            label: PANEL_NAME.COORD_LIST,
                            name: PANEL_NAME.COORD_LIST
                        }, {
                            default: (0, vue_2.withCtx)(() => [
                                (0, vue_2.createVNode)(CoordList_vue_1.default, {
                                    ref_key: "coordListRef",
                                    ref: coordListRef
                                }, null, 512)
                            ]),
                            _: 1
                        }, 8, ["label", "name"])
                    ]),
                    _: 1
                }, 8, ["modelValue", "class"]),
                (0, vue_2.createElementVNode)("div", _hoisted_7, [
                    (0, vue_2.createElementVNode)("div", _hoisted_8, [
                        (0, vue_2.createElementVNode)("div", _hoisted_9, [
                            (0, vue_2.createElementVNode)("div", null, [
                                ((0, vue_2.unref)(curSinglePointState) !== SINGLE_POINT_STATE.RUNNING)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_el_button, {
                                        key: 0,
                                        type: "success",
                                        size: "large",
                                        icon: "VideoPlay",
                                        onClick: singlePointRun
                                    }, {
                                        default: (0, vue_2.withCtx)(() => [
                                            (0, vue_2.createTextVNode)("单点运行 ")
                                        ]),
                                        _: 1
                                    }))
                                    : ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_el_button, {
                                        key: 1,
                                        type: "danger",
                                        size: "large",
                                        icon: "VideoPause",
                                        onClick: singlePointRun
                                    }, {
                                        default: (0, vue_2.withCtx)(() => [
                                            (0, vue_2.createTextVNode)("单点运行 ")
                                        ]),
                                        _: 1
                                    }))
                            ]),
                            (0, vue_2.createElementVNode)("div", null, [
                                (0, vue_2.createVNode)(_component_el_button, {
                                    onClick: savePoint,
                                    icon: "Download",
                                    size: "large",
                                    type: "primary"
                                }, {
                                    default: (0, vue_2.withCtx)(() => [
                                        (0, vue_2.createTextVNode)("存点")
                                    ]),
                                    _: 1
                                })
                            ])
                        ])
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_10, [
                        (0, vue_2.createVNode)(CtrlBtn_vue_1.default, {
                            onMoveUpTouch: _cache[3] || (_cache[3] = ($event) => (ctrlBtnMove('moveUp'))),
                            onMoveDownTouch: _cache[4] || (_cache[4] = ($event) => (ctrlBtnMove('moveDown'))),
                            onRotatLeftTouch: _cache[5] || (_cache[5] = ($event) => (ctrlBtnMove('rotatLeft'))),
                            onRotatRightTouch: _cache[6] || (_cache[6] = ($event) => (ctrlBtnMove('rotatRight'))),
                            onMoveUpEnd: ctrlBtnStop,
                            onMoveDownEnd: ctrlBtnStop,
                            onRotatLeftEnd: ctrlBtnStop,
                            onRotatRightEnd: ctrlBtnStop,
                            onChangeSpeed: onCenterLeftClk,
                            onStopEvt: onCtrlStopEvt,
                            ref_key: "ctrlBtnRef",
                            ref: ctrlBtnRef,
                            stopEvt: (0, vue_2.unref)(isStopCtrlBtn)
                        }, null, 8, ["stopEvt"])
                    ]),
                    (0, vue_2.createVNode)(_component_el_dropdown, {
                        trigger: "click",
                        size: "large",
                        onCommand: handleCommand
                    }, {
                        dropdown: (0, vue_2.withCtx)(() => [
                            (0, vue_2.createVNode)(_component_el_dropdown_menu, null, {
                                default: (0, vue_2.withCtx)(() => [
                                    (0, vue_2.createVNode)(_component_el_dropdown_item, {
                                        command: TOOL_BOX_CMD.LEVELLING
                                    }, {
                                        default: (0, vue_2.withCtx)(() => [
                                            (0, vue_2.createTextVNode)("调平")
                                        ]),
                                        _: 1
                                    }, 8, ["command"]),
                                    (0, vue_2.createVNode)(_component_el_dropdown_item, {
                                        command: TOOL_BOX_CMD.RECONNECT
                                    }, {
                                        default: (0, vue_2.withCtx)(() => [
                                            (0, vue_2.createTextVNode)("重新连接")
                                        ]),
                                        _: 1
                                    }, 8, ["command"]),
                                    (0, vue_2.createVNode)(_component_el_dropdown_item, {
                                        command: TOOL_BOX_CMD.RESET_POINT_DATA
                                    }, {
                                        default: (0, vue_2.withCtx)(() => [
                                            (0, vue_2.createTextVNode)("重置点位数据")
                                        ]),
                                        _: 1
                                    }, 8, ["command"])
                                ]),
                                _: 1
                            })
                        ]),
                        default: (0, vue_2.withCtx)(() => [
                            (0, vue_2.createVNode)(_component_el_button, {
                                type: "primary",
                                circle: "",
                                size: "large",
                                class: "auxiliary-button"
                            }, {
                                default: (0, vue_2.withCtx)(() => [
                                    (0, vue_2.createVNode)(_component_el_icon, { size: "25" }, {
                                        default: (0, vue_2.withCtx)(() => [
                                            (0, vue_2.createVNode)(_component_SuitcaseLine)
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    })
                ]),
                (0, vue_2.createVNode)(index_vue_1.default, {
                    ref_key: "robotConfigDialog",
                    ref: robotConfigDialog,
                    onConnected: onConnected
                }, null, 512)
            ]));
        };
    } }));
